import Account from './Account';
import Auth from './Auth';
import User from './User';
var Keycloak = /** @class */ (function () {
    function Keycloak() {
    }
    /**
     *
     * @param config
     * @param redirect
     */
    Keycloak.init = function (config, redirect) {
        if (config === void 0) { config = null; }
        if (redirect === void 0) { redirect = ''; }
        if (config !== null) {
            Keycloak.config = config;
            Keycloak.redirect = redirect;
        }
    };
    /**
     *
     * @returns Auth class
     */
    Keycloak.auth = function () {
        var args = new Auth(Keycloak.config, Keycloak.redirect);
        return args;
    };
    /**
     *
     * @param token
     * @returns User class
     */
    Keycloak.user = function (token) {
        var args = new User(Keycloak.config, token);
        return args;
    };
    /**
     *
     * @param redirect
     * @returns
     */
    Keycloak.account = function (redirect) {
        if (redirect === void 0) { redirect = ''; }
        var args = new Account(Keycloak.config, redirect);
        return args;
    };
    return Keycloak;
}());
export default Keycloak;
